<script setup lang="ts">
const route = useRoute()
const { locale } = useI18n()

const { data, error, pending } = usePage(
  `/api/gluon/fetchResearchPage/${locale.value}/search.js`,
  {
    lazy: true
  }
)

if (error.value) {
  throw createError({
    message: error.value.message,
    statusCode: error.value.statusCode ?? 404
  })
}

useHead({
  meta: [
    {
      hid: "robots",
      name: "robots",
      content: "noindex,nofollow"
    }
  ]
})
</script>

<template>
  <div class="search">
    <div class="search-items-wrapper">
      <AlgoliaListingPageSearch>
        <div class="grid-standard md:pt-6" id="algolia-plp-filters">
          <AlgoliaPlpFilters />
        </div>
        <GAListPageList :name="`Search Page: ${route.query.query}`">
          <AisHits>
            <template #default="{ items }">
              <div v-if="items.length > 0">
                <GridListCategory
                  :productsList="items"
                  :isSearch="true"
                  :list-name="`Search Page: ${route.query.query}`"
                />
                <div class="grid-standard">
                  <DynamicContent
                    v-if="data && data.content && !pending"
                    class="cms-content negative-margined col-span-full"
                    :components="data.content"
                  />

                  <SuggestionsPopularSearch
                    class="col-span-full"
                    :title="$t('suggested.relatedSearch.popularQueries')"
                  />
                </div>
              </div>
              <div v-else>
                <PagesNoResults :product="route.query.query" />
              </div>
            </template>
          </AisHits>
        </GAListPageList>
      </AlgoliaListingPageSearch>
    </div>
  </div>
</template>
